export enum FormaInformacaoEnum {
    CONFIRMACAO = 'Confirmação',
    ACESSO_COMPLETO = 'Acesso completo',
    CORRECAO = 'Correção ou atualização',
    ANONIMIZACAO = 'Anonimização, bloqueio ou eliminação'
}